import { t } from "@/i18n-js/instance";

import { CourseAccessField } from "../fields/CourseAccessField";
import { SectionShell } from "../SectionShell";

export const CourseAccessSection = () => (
  <SectionShell title={t("courses.access")}>
    <CourseAccessField />
  </SectionShell>
);
